
<div class="flex h-screen overflow-hidden">

  <!-- Sidebar: toggleable but never overlays — collapses width and pushes content -->
  <div
    id="app-sidebar"
    class="shrink-0 flex flex-col h-full select-none bg-primary-50 border-r border-surface-200 overflow-hidden transition-[width] duration-300 ease-in-out"
    [ngClass]="isSidebarOpen() ? 'w-[240px]' : 'w-0 border-r-0'"
  >
    <!-- Inner wrapper fixed at 240px so content doesn't squish during transition -->
    <div class="w-[240px] flex flex-col h-full">
      <div class="flex items-center justify-center px-14 py-6">
        <img src="assets/images/platform-logo.svg" alt="Central Land Council" width="240px"/>
      </div>

      <div class="relative flex-1 min-h-0 flex flex-col">
        <div #menuScroller class="overflow-y-auto flex-1 p-2 flex flex-col gap-4" (scroll)="updateMenuFade()">
          <ul #menuList class="list-none m-0 flex flex-col gap-1">
            @for (item of navItems; track item) {
              <side-menu-item [item]="item"></side-menu-item>
            }
          </ul>
        </div>
        <!-- Top fade, only while the menu is scrolled down; inset clears the scrollbar -->
        <div class="absolute top-0 left-0 h-12 pointer-events-none bg-[linear-gradient(to_bottom,var(--p-primary-50),transparent)] transition-opacity duration-200"
             [class.opacity-0]="!showMenuFade()"
             [style.right.px]="menuScrollbarWidth()"></div>
      </div>

      <div class="mt-auto border-surface-200 border-t">
        <a class="flex p-3.5 bg-primary-100 border-t border-surface-200 justify-start items-center gap-3.5 flex-wrap cursor-pointer hover:bg-primary-200 transition-colors"
           (click)="userMenu.toggle($event)">
          <div class="w-7 h-7 bg-white rounded-2xl inline-flex flex-col justify-center items-center text-avatar-color text-surface-700 text-sm">
            {{user()?.initials ?? '?'}}
          </div>
          <div class="flex-1 justify-start text-surface-900">
            <div class="text-surface-900">
              {{user()?.name ?? 'Unknown User'}}
            </div>
          </div>
          <i class="fa-solid fa-chevron-up ml-auto text-surface-500 text-sm"></i>
        </a>
      </div>
      <p-menu [style]="{'width': '240px'}" #userMenu [model]="userMenuItems" [popup]="true" appendTo="body"></p-menu>
    </div>
  </div>

  <!-- Main Content -->
  <div class="flex-1 flex flex-col overflow-hidden min-w-0">
    <!-- Top Navigation Bar -->
    <div class="flex justify-between items-center pl-5 pr-7 py-3.5 bg-primary-50 border-b border-surface-200 shrink-0">
      <div class="flex items-center gap-2">
        <p-button icon="fa-regular fa-sidebar fa-xl text-surface-800" [text]="true" (click)="toggleSidebar()"></p-button>
        @if (permissionService.canQuickSearch()) {
          <div class="w-fit h-fit bg-white rounded-3xl">
            <p-button
                    styleClass="min-w-40 justify-between"
                    severity="primary"
                    size="small"
                    ariaLabel="Search TAs"
                    (click)="quickSearchOpen.set(true)">
              <span class="font-['Inter']">Quick Search</span>
              <svg class="w-[22.3px] h-[12.25px] block" viewBox="0 0 992 544" fill="currentColor" aria-hidden="true">
                <path d="M512.317 291C516.427 306.968 521.994 322.351 528.867 337H68C55.2975 337 45 326.703 45 314C45 301.297 55.2975 291 68 291H512.317ZM508.729 175C505.867 189.925 504.264 205.296 504.031 221H184C171.297 221 161 210.703 161 198C161 185.297 171.297 175 184 175H508.729ZM559 59C560.188 59 561.355 59.089 562.495 59.2627C551.094 73.3822 541.119 88.7014 532.787 105H325C312.297 105 302 94.7025 302 82C302 69.2975 312.297 59 325 59H559Z"/>
                <path d="M608 224C608 136 680 64 768 64C856 64 928 136 928 224C928 312 856 384 768 384C680 384 608 312 608 224ZM639 387C674 415 719 432 768 432C883 432 976 339 976 224C976 109 883 16 768 16C653 16 560 109 560 224C560 273 577 318 605 353L471 487C462 496 462 512 471 521C480 530 496 530 505 521L639 387Z"/>
              </svg>
            </p-button>
          </div>
        }
      </div>

      <div class="flex items-center gap-4">
        <div class="flex items-center gap-4">
          @if (!!envName() && store.showEnvName()){
            <span class="bg-red-500 text-gray-50 px-2 outline-4 outline-double outline-blue-700">{{envName()!.toUpperCase()}} <button (click)="hideEnvName()" pButton icon="pi pi-times" [rounded]="true" severity="danger" size="small"></button> </span>
          }

          <i class="fa-solid fa-circle-question text-primary fa-xl cursor-pointer" [pTooltip]="'Download User Manual'" (click)="getUserManual()"></i>
          <div class="justify-start text-surface-700 text-2xl font-normal">
            Travel Allowance Platform
            <span class="text-xs text-surface-300">{{version()}}</span>
          </div>
        </div>

      </div>
    </div>
    <bread-crumb-bar></bread-crumb-bar>

    <!-- Scrollable Content Area -->
    <div class="flex-1 overflow-auto text-surface-700">
      <div class="min-w-[720px] h-full">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
<p-confirmdialog></p-confirmdialog>
@if (permissionService.canQuickSearch()) {
  <quick-search [(visible)]="quickSearchOpen"></quick-search>
}
<p-toast></p-toast>
<chat-window></chat-window>
